const GTMService = {
  pushData (userData = {}) {
    window.dataLayer = window.dataLayer || []
    const { email, firstName, lastName } = userData
    // eslint-disable-next-line no-undef
    dataLayer.push({ event: 'User Data', email, firstName, lastName })
    // eslint-disable-next-line no-undef
    dataLayer.push(email, firstName, lastName)
  }
}

export default GTMService
